import React from 'react';

const Asterisk = () => {
  return (
    <span className='text-red-3'>*</span>
  );
};

export default Asterisk;
